module.exports = __webpack_public_path__ + "img/1480320467.495deeed.jpg";